import { createSlice } from "@reduxjs/toolkit";
import { QualificationTypeEnum } from "../../common/enums/QualificationTypeEnum";

interface DashboardPageInterface {
    achievedCertificates: {
        currentPage: number;
        itemsPerPage: number;
        itemsPerPageSelect: { value: number; activeValue: boolean }[];
    };
    expiringSoonCertificates: {
        currentPage: number;
        itemsPerPage: number;
        itemsPerPageSelect: { value: number; activeValue: boolean }[];
    };
    scheduledQualifications: {
        currentPage: number;
        itemsPerPage: number;
        itemsPerPageSelect: { value: number; activeValue: boolean }[];
    };
    employeeWidget: {
        currentPage: number;
    };
    missingCertificatesWidget: {
        currentPage: number;
        filters: {
            activeTab: QualificationTypeEnum;
        };
    };
}

const initialState: DashboardPageInterface = {
    achievedCertificates: {
        currentPage: 1,
        itemsPerPage: 5,
        itemsPerPageSelect: [
            { value: 5, activeValue: true },
            { value: 12, activeValue: false },
            { value: 25, activeValue: false },
        ],
    },
    expiringSoonCertificates: {
        currentPage: 1,
        itemsPerPage: 5,
        itemsPerPageSelect: [
            { value: 5, activeValue: true },
            { value: 12, activeValue: false },
            { value: 25, activeValue: false },
        ],
    },
    scheduledQualifications: {
        currentPage: 1,
        itemsPerPage: 5,
        itemsPerPageSelect: [
            { value: 5, activeValue: true },
            { value: 12, activeValue: false },
            { value: 25, activeValue: false },
        ],
    },
    employeeWidget: {
        currentPage: 1,
    },
    missingCertificatesWidget: {
        currentPage: 1,
        filters: {
            activeTab: QualificationTypeEnum.PERSON,
        },
    },
};

const dashboardSlice = createSlice({
    name: "dashboard",
    initialState,
    reducers: {
        setAchievedCertificatesCurrentPage: (state, action) => {
            state.achievedCertificates.currentPage = action.payload;
        },
        setAchievedCertificatesItemsPerPage: (state, action) => {
            state.achievedCertificates.itemsPerPage = action.payload;
            state.achievedCertificates.currentPage = 1;
            state.achievedCertificates.itemsPerPageSelect =
                state.achievedCertificates.itemsPerPageSelect.map((item) => ({
                    ...item,
                    activeValue: item.value === action.payload,
                }));
        },
        setExpiringSoonCertificatesCurrentPage: (state, action) => {
            state.expiringSoonCertificates.currentPage = action.payload;
        },
        setExpiringSoonCertificatesItemsPerPage: (state, action) => {
            state.expiringSoonCertificates.itemsPerPage = action.payload;
            state.expiringSoonCertificates.currentPage = 1;
            state.expiringSoonCertificates.itemsPerPageSelect =
                state.expiringSoonCertificates.itemsPerPageSelect.map(
                    (item) => ({
                        ...item,
                        activeValue: item.value === action.payload,
                    }),
                );
        },
        setScheduledQualificationsCurrentPage: (state, action) => {
            state.scheduledQualifications.currentPage = action.payload;
        },
        setScheduledQualificationsItemsPerPage: (state, action) => {
            state.scheduledQualifications.itemsPerPage = action.payload;
            state.scheduledQualifications.currentPage = 1;
            state.scheduledQualifications.itemsPerPageSelect =
                state.scheduledQualifications.itemsPerPageSelect.map(
                    (item) => ({
                        ...item,
                        activeValue: item.value === action.payload,
                    }),
                );
        },
        setEmployeeWidgetCurrentPage: (state, action) => {
            state.employeeWidget.currentPage = action.payload;
        },
        setMissingCertificatesWidgetCurrentPage: (state, action) => {
            state.missingCertificatesWidget.currentPage = action.payload;
        },
        setMissingCertificatesWidgetFilters: (state, action) => {
            state.missingCertificatesWidget.filters = action.payload;
        },
    },
});

export const dashboardReducer = dashboardSlice.reducer;

export const {
    setAchievedCertificatesCurrentPage,
    setAchievedCertificatesItemsPerPage,
    setExpiringSoonCertificatesCurrentPage,
    setExpiringSoonCertificatesItemsPerPage,
    setScheduledQualificationsCurrentPage,
    setScheduledQualificationsItemsPerPage,
    setEmployeeWidgetCurrentPage,
    setMissingCertificatesWidgetCurrentPage,
    setMissingCertificatesWidgetFilters,
} = dashboardSlice.actions;
